import Error, { EErrorType } from "uicomponents/Error";

export function Page404() {
  return (
    <div data-testid="page-404">
      <Error type={EErrorType.PageNotFound} />
    </div>
  );
}
